export class EasiHeatGen4GatewayAvailabilityInputs {
  CountryCode: string;
}

